import { render, staticRenderFns } from "./LocalUIPassword.vue?vue&type=template&id=5434f64e"
import script from "./LocalUIPassword.vue?vue&type=script&lang=js"
export * from "./LocalUIPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports